import React, {
    useEffect,
    useState
} from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    ModalEconomiaSubtitulo,
    BotonCerrarModal,

    ModalSeccion,
    ModalSeccionTitulo,
    ModalAcciones,
    ModalScrollContenido,

    BotonPrincipal,
    BotonSecundario,

    CobroFormulario,
    CobroCamposGrid,
    CobroCampo,
    CobroLabel,
    CobroInput,
    CobroSelect,
    CobroTextarea
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement(
    '#root'
);


/*
====================================
FECHA DE HOY
====================================
*/

const getFechaHoy = () => {

    const hoy =
        new Date();


    const year =
        hoy.getFullYear();


    const month =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            '0'
        );


    const day =
        String(
            hoy.getDate()
        ).padStart(
            2,
            '0'
        );


    return `${year}-${month}-${day}`;

};


/*
====================================
ESTADO INICIAL
====================================
*/

const getEstadoInicial = () => ({

    nombre:
        '',

    descripcion:
        '',

    fecha_desde:
        getFechaHoy(),


    /*
    ====================================
    FEE
    ====================================
    */

    fee_tipo:
        'PORCENTAJE',

    fee_valor:
        '',

    fee_base:
        'PRESTACION',

    fee_mensual_condicion:
        'MES_CON_PRESTACIONES',


    /*
    ====================================
    QUÉ PRESTACIONES PAGAN
    ====================================
    */

    paga_sesion_paciente:
        true,

    paga_reunion_padres:
        false,

    paga_reunion_colegio:
        false,

    paga_reunion_profesionales:
        false,


    /*
    ====================================
    VENCIMIENTO
    ====================================
    */

    vencimiento_opcion:
        'FIN_MES_SIGUIENTE',

    vencimiento_dia:
        '10'

});


/*
====================================
CENTRO MODAL
====================================
*/

const CentroModal = ({

    isOpen,

    onClose,

    onGuardar,

    guardando

}) => {


    const [
        formulario,
        setFormulario
    ] = useState(
        getEstadoInicial()
    );


    const [
        errorFormulario,
        setErrorFormulario
    ] = useState('');


    /*
    ====================================
    REINICIAR AL ABRIR
    ====================================
    */

    useEffect(() => {

        if (!isOpen) {

            return;

        }


        setFormulario(
            getEstadoInicial()
        );


        setErrorFormulario('');

    }, [
        isOpen
    ]);


    /*
    ====================================
    CAMBIAR CAMPO
    ====================================
    */

    const cambiarCampo = (
        e
    ) => {

        const {

            name,

            value,

            type,

            checked

        } = e.target;


        setFormulario(
            (actual) => ({

                ...actual,

                [name]:
                    type ===
                        'checkbox'

                        ? checked

                        : value

            })
        );


        setErrorFormulario('');

    };

    /*
    ====================================
    CAMBIAR VALOR DEL FEE
    ====================================

    Aceptamos:

    30
    30.5
    30,5
    30.50
    30,50

    No permitimos letras, %, signos,
    notación científica ni más de
    dos decimales.
    ====================================
    */

    const cambiarFeeValor = (
        e
    ) => {

        const valor =
            e.target.value;


        /*
        Vacío:
        se permite mientras está escribiendo.
        */

        if (
            valor === ''
        ) {

            setFormulario(
                (actual) => ({

                    ...actual,

                    fee_valor:
                        ''

                })
            );


            setErrorFormulario('');

            return;

        }


        /*
        ====================================
        FORMATO PERMITIDO
        ====================================
        */

        const formatoValido =
            /^\d*(?:[.,]\d{0,2})?$/
                .test(
                    valor
                );


        if (
            !formatoValido
        ) {

            /*
            No actualizamos el estado.

            Por ejemplo, si intenta escribir:
            30%
            el % directamente no entra.
            */

            return;

        }


        setFormulario(
            (actual) => ({

                ...actual,

                fee_valor:
                    valor

            })
        );


        setErrorFormulario('');

    };

    /*
    ====================================
    RESOLVER VENCIMIENTO
    ====================================
    */

    const resolverVencimiento = () => {

        switch (
            formulario
                .vencimiento_opcion
        ) {

            case 'INMEDIATO':

                return {

                    vencimiento_tipo:
                        'INMEDIATO',

                    vencimiento_meses:
                        0,

                    vencimiento_dia:
                        null

                };


            case 'FIN_MES_ACTUAL':

                return {

                    vencimiento_tipo:
                        'FIN_MES',

                    vencimiento_meses:
                        0,

                    vencimiento_dia:
                        null

                };


            case 'DIA_MES_SIGUIENTE':

                return {

                    vencimiento_tipo:
                        'DIA_MES',

                    vencimiento_meses:
                        1,

                    vencimiento_dia:
                        Number(
                            formulario
                                .vencimiento_dia
                        )

                };


            case 'FIN_MES_SIGUIENTE':
            default:

                return {

                    vencimiento_tipo:
                        'FIN_MES',

                    vencimiento_meses:
                        1,

                    vencimiento_dia:
                        null

                };

        }

    };


    /*
    ====================================
    VALIDAR
    ====================================
    */

    const validarFormulario = () => {

        if (
            !formulario
                .nombre
                .trim()
        ) {

            return 'Ingresá el nombre del centro.';

        }


        if (
            !formulario
                .fecha_desde
        ) {

            return 'Ingresá desde qué fecha rige la configuración.';

        }


        const feeValorTexto =
            String(
                formulario
                    .fee_valor
            )
                .trim();


        /*
        ====================================
        VALIDAR FORMATO
        ====================================
        */

        if (
            !/^\d+(?:[.,]\d{1,2})?$/
                .test(
                    feeValorTexto
                )
        ) {

            return 'Ingresá un valor válido. Podés usar coma o punto para los decimales.';

        }


        /*
        ====================================
        NORMALIZAR DECIMAL
        ====================================

        30,5
        → 30.5

        30.5
        → 30.5
        ====================================
        */

        const feeValor =
            Number(
                feeValorTexto.replace(
                    ',',
                    '.'
                )
            );


        if (
            !Number.isFinite(
                feeValor
            ) ||
            feeValor <= 0
        ) {

            return 'El valor debe ser mayor a 0.';

        }


        if (
            formulario.fee_tipo ===
                'PORCENTAJE' &&
            feeValor > 100
        ) {

            return 'El porcentaje no puede superar el 100%.';

        }


        if (
            formulario
                .fee_tipo ===
                'FIJO_MENSUAL' &&
            !formulario
                .fee_mensual_condicion
        ) {

            return 'Seleccioná cuándo corresponde generar el monto mensual.';

        }


        if (
            formulario
                .vencimiento_opcion ===
                'DIA_MES_SIGUIENTE'
        ) {

            const dia =
                Number(
                    formulario
                        .vencimiento_dia
                );


            if (
                !Number.isInteger(
                    dia
                ) ||
                dia < 1 ||
                dia > 31
            ) {

                return 'El día de vencimiento debe estar entre 1 y 31.';

            }

        }


        return null;

    };


    /*
    ====================================
    GUARDAR
    ====================================
    */

    const handleGuardar = async (
        e
    ) => {

        e.preventDefault();


        if (
            typeof onGuardar !==
                'function'
        ) {

            return;

        }


        const error =
            validarFormulario();


        if (error) {

            setErrorFormulario(
                error
            );

            return;

        }


        const feeValor =
            Number(
                String(
                    formulario
                        .fee_valor
                )
                    .trim()
                    .replace(
                        ',',
                        '.'
                    )
            );


        const vencimiento =
            resolverVencimiento();


        /*
        ====================================
        BASE DEL FEE
        ====================================

        Para FIJO_MENSUAL:

        MES_CON_COBROS
        → COBRO

        resto
        → PRESTACION

        Para los demás tipos usamos
        lo elegido por el profesional.
        ====================================
        */

        const feeBase =

            formulario
                .fee_tipo ===
                'FIJO_MENSUAL'

                ? (
                    formulario
                        .fee_mensual_condicion ===
                        'MES_CON_COBROS'

                        ? 'COBRO'

                        : 'PRESTACION'
                )

                : formulario
                    .fee_base;


        const datos = {

            nombre:
                formulario
                    .nombre
                    .trim(),

            descripcion:
                formulario
                    .descripcion
                    .trim() ||
                null,

            fecha_desde:
                formulario
                    .fecha_desde,


            configuracion: {

                fee_tipo:
                    formulario
                        .fee_tipo,

                fee_valor:
                    feeValor,

                fee_base:
                    feeBase,

                fee_mensual_condicion:

                    formulario
                        .fee_tipo ===
                        'FIJO_MENSUAL'

                        ? formulario
                            .fee_mensual_condicion

                        : null,


                paga_sesion_paciente:
                    formulario
                        .paga_sesion_paciente,

                paga_reunion_padres:
                    formulario
                        .paga_reunion_padres,

                paga_reunion_colegio:
                    formulario
                        .paga_reunion_colegio,

                paga_reunion_profesionales:
                    formulario
                        .paga_reunion_profesionales,


                vencimiento_tipo:
                    vencimiento
                        .vencimiento_tipo,

                vencimiento_meses:
                    vencimiento
                        .vencimiento_meses,

                vencimiento_dia:
                    vencimiento
                        .vencimiento_dia,

                observacion:
                    null

            }

        };


        const guardado =
            await onGuardar(
                datos
            );


        if (guardado) {

            setFormulario(
                getEstadoInicial()
            );

            setErrorFormulario('');

            onClose();

        }

    };


    /*
    ====================================
    CERRAR
    ====================================
    */

    const handleCerrar = () => {

        if (guardando) {

            return;

        }


        setFormulario(
            getEstadoInicial()
        );


        setErrorFormulario('');


        onClose();

    };


    /*
    ====================================
    TEXTO DEL VALOR
    ====================================
    */

    const labelValor =

        formulario
            .fee_tipo ===
            'PORCENTAJE'

            ? 'Porcentaje'

            : formulario
                .fee_tipo ===
                'FIJO_PRESTACION'

                ? 'Importe por prestación'

                : 'Importe mensual por paciente';


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <Modal

            isOpen={
                isOpen
            }

            onRequestClose={
                handleCerrar
            }

            shouldCloseOnOverlayClick={
                !guardando
            }

            shouldCloseOnEsc={
                !guardando
            }

            style={{

                overlay: {

                    zIndex:
                        2000,

                    backgroundColor:
                        'rgba(0, 0, 0, 0.45)',

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    padding:
                        '1rem'

                },

                content: {

                    position:
                        'relative',

                    inset:
                        'auto',

                    border:
                        'none',

                    background:
                        'transparent',

                    padding:
                        0,

                    width:
                        '100%',

                    maxWidth:
                        '700px',

                    maxHeight:
                        '90vh',

                    overflow:
                        'hidden',

                    boxSizing:
                        'border-box'

                }

            }}
        >

            <ModalEconomiaContenido>


                <ModalEconomiaCabecera>

                    <div>

                        <ModalEconomiaTitulo>
                            Agregar centro
                        </ModalEconomiaTitulo>


                        <ModalEconomiaSubtitulo>
                            Definí las condiciones
                            económicas generales del
                            centro. Después cada
                            paciente podrá tener
                            excepciones propias.
                        </ModalEconomiaSubtitulo>

                    </div>


                    <BotonCerrarModal

                        type="button"

                        disabled={
                            guardando
                        }

                        onClick={
                            handleCerrar
                        }
                    >
                        ×
                    </BotonCerrarModal>

                </ModalEconomiaCabecera>


                <ModalScrollContenido>

                    <CobroFormulario
                        as="form"
                        onSubmit={
                            handleGuardar
                        }
                    >


                        {/*
                        ====================================
                        CENTRO
                        ====================================
                        */}

                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Centro
                            </ModalSeccionTitulo>


                            <CobroCamposGrid>

                                <CobroCampo>

                                    <CobroLabel>
                                        Nombre *
                                    </CobroLabel>


                                    <CobroInput

                                        name="nombre"

                                        value={
                                            formulario
                                                .nombre
                                        }

                                        placeholder="Ej. Centro A"

                                        maxLength={
                                            150
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    />

                                </CobroCampo>


                                <CobroCampo>

                                    <CobroLabel>
                                        Vigente desde *
                                    </CobroLabel>


                                    <CobroInput

                                        type="date"

                                        name="fecha_desde"

                                        value={
                                            formulario
                                                .fecha_desde
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    />

                                </CobroCampo>

                            </CobroCamposGrid>


                            <CobroCampo
                                style={{
                                    marginTop:
                                        '0.8rem'
                                }}
                            >

                                <CobroLabel>
                                    Descripción opcional
                                </CobroLabel>


                                <CobroTextarea

                                    name="descripcion"

                                    value={
                                        formulario
                                            .descripcion
                                    }

                                    placeholder="Información interna sobre el centro"

                                    maxLength={
                                        500
                                    }

                                    disabled={
                                        guardando
                                    }

                                    onChange={
                                        cambiarCampo
                                    }
                                />

                            </CobroCampo>

                        </ModalSeccion>


                        {/*
                        ====================================
                        CONDICIÓN ECONÓMICA
                        ====================================
                        */}

                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Condición económica
                            </ModalSeccionTitulo>


                            <CobroCamposGrid>

                                <CobroCampo>

                                    <CobroLabel>
                                        Tipo de fee
                                    </CobroLabel>


                                    <CobroSelect

                                        name="fee_tipo"

                                        value={
                                            formulario
                                                .fee_tipo
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    >

                                        <option
                                            value="PORCENTAJE"
                                        >
                                            Porcentaje
                                        </option>

                                        <option
                                            value="FIJO_PRESTACION"
                                        >
                                            Importe fijo por prestación
                                        </option>

                                        <option
                                            value="FIJO_MENSUAL"
                                        >
                                            Importe fijo mensual
                                        </option>

                                    </CobroSelect>

                                </CobroCampo>


                                <CobroCampo>

                                    <CobroLabel>
                                        {labelValor} *
                                    </CobroLabel>


                                    <CobroInput

                                        type="text"

                                        inputMode="decimal"

                                        autoComplete="off"

                                        name="fee_valor"

                                        value={
                                            formulario
                                                .fee_valor
                                        }

                                        placeholder={
                                            formulario
                                                .fee_tipo ===
                                                'PORCENTAJE'

                                                ? 'Ej. 30 o 30,5'

                                                : 'Ej. 15000'
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarFeeValor
                                        }
                                    />

                                </CobroCampo>

                            </CobroCamposGrid>


                            {
                                formulario
                                    .fee_tipo !==
                                    'FIJO_MENSUAL'

                                    ? (

                                        <CobroCampo
                                            style={{
                                                marginTop:
                                                    '0.8rem'
                                            }}
                                        >

                                            <CobroLabel>
                                                ¿Cuándo se genera lo que corresponde al centro?
                                            </CobroLabel>


                                            <CobroSelect

                                                name="fee_base"

                                                value={
                                                    formulario
                                                        .fee_base
                                                }

                                                disabled={
                                                    guardando
                                                }

                                                onChange={
                                                    cambiarCampo
                                                }
                                            >

                                                <option
                                                    value="PRESTACION"
                                                >
                                                    Cuando realizo la prestación
                                                </option>

                                                <option
                                                    value="COBRO"
                                                >
                                                    Cuando recibo el pago del paciente
                                                </option>

                                            </CobroSelect>

                                        </CobroCampo>

                                    )

                                    : (

                                        <CobroCampo
                                            style={{
                                                marginTop:
                                                    '0.8rem'
                                            }}
                                        >

                                            <CobroLabel>
                                                ¿Cuándo corresponde generar el monto mensual?
                                            </CobroLabel>


                                            <CobroSelect

                                                name="fee_mensual_condicion"

                                                value={
                                                    formulario
                                                        .fee_mensual_condicion
                                                }

                                                disabled={
                                                    guardando
                                                }

                                                onChange={
                                                    cambiarCampo
                                                }
                                            >

                                                <option
                                                    value="MES_CON_PRESTACIONES"
                                                >
                                                    Si hubo prestaciones durante el mes
                                                </option>

                                                <option
                                                    value="MES_VINCULADO"
                                                >
                                                    Si el paciente estuvo vinculado al centro
                                                </option>

                                                <option
                                                    value="MES_CON_COBROS"
                                                >
                                                    Si hubo cobros del paciente durante el mes
                                                </option>

                                            </CobroSelect>

                                        </CobroCampo>

                                    )
                            }

                        </ModalSeccion>


                        {/*
                        ====================================
                        TIPOS DE PRESTACIÓN
                        ====================================
                        */}

                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Qué prestaciones pagan al centro
                            </ModalSeccionTitulo>


                            <div
                                style={{
                                    display:
                                        'grid',

                                    gridTemplateColumns:
                                        'repeat(2, minmax(0, 1fr))',

                                    gap:
                                        '0.7rem'
                                }}
                            >

                                <label
                                    style={{
                                        display:
                                            'flex',

                                        alignItems:
                                            'center',

                                        gap:
                                            '0.5rem',

                                        fontSize:
                                            '0.75rem',

                                        color:
                                            '#263434'
                                    }}
                                >

                                    <input
                                        type="checkbox"

                                        name="paga_sesion_paciente"

                                        checked={
                                            formulario
                                                .paga_sesion_paciente
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    />

                                    Sesión con paciente

                                </label>


                                <label
                                    style={{
                                        display:
                                            'flex',

                                        alignItems:
                                            'center',

                                        gap:
                                            '0.5rem',

                                        fontSize:
                                            '0.75rem',

                                        color:
                                            '#263434'
                                    }}
                                >

                                    <input
                                        type="checkbox"

                                        name="paga_reunion_padres"

                                        checked={
                                            formulario
                                                .paga_reunion_padres
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    />

                                    Reunión con padres

                                </label>


                                <label
                                    style={{
                                        display:
                                            'flex',

                                        alignItems:
                                            'center',

                                        gap:
                                            '0.5rem',

                                        fontSize:
                                            '0.75rem',

                                        color:
                                            '#263434'
                                    }}
                                >

                                    <input
                                        type="checkbox"

                                        name="paga_reunion_colegio"

                                        checked={
                                            formulario
                                                .paga_reunion_colegio
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    />

                                    Reunión con colegio

                                </label>


                                <label
                                    style={{
                                        display:
                                            'flex',

                                        alignItems:
                                            'center',

                                        gap:
                                            '0.5rem',

                                        fontSize:
                                            '0.75rem',

                                        color:
                                            '#263434'
                                    }}
                                >

                                    <input
                                        type="checkbox"

                                        name="paga_reunion_profesionales"

                                        checked={
                                            formulario
                                                .paga_reunion_profesionales
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    />

                                    Reunión con profesionales

                                </label>

                            </div>

                        </ModalSeccion>


                        {/*
                        ====================================
                        VENCIMIENTO
                        ====================================
                        */}

                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Forma habitual de liquidación
                            </ModalSeccionTitulo>


                            <CobroCamposGrid>

                                <CobroCampo>

                                    <CobroLabel>
                                        Vencimiento
                                    </CobroLabel>


                                    <CobroSelect

                                        name="vencimiento_opcion"

                                        value={
                                            formulario
                                                .vencimiento_opcion
                                        }

                                        disabled={
                                            guardando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    >

                                        <option
                                            value="INMEDIATO"
                                        >
                                            Inmediato
                                        </option>

                                        <option
                                            value="FIN_MES_ACTUAL"
                                        >
                                            Fin del mismo mes
                                        </option>

                                        <option
                                            value="FIN_MES_SIGUIENTE"
                                        >
                                            Fin del mes siguiente
                                        </option>

                                        <option
                                            value="DIA_MES_SIGUIENTE"
                                        >
                                            Día específico del mes siguiente
                                        </option>

                                    </CobroSelect>

                                </CobroCampo>


                                {
                                    formulario
                                        .vencimiento_opcion ===
                                        'DIA_MES_SIGUIENTE'

                                        ? (

                                            <CobroCampo>

                                                <CobroLabel>
                                                    Día
                                                </CobroLabel>


                                                <CobroInput

                                                    type="number"

                                                    min="1"

                                                    max="31"

                                                    name="vencimiento_dia"

                                                    value={
                                                        formulario
                                                            .vencimiento_dia
                                                    }

                                                    disabled={
                                                        guardando
                                                    }

                                                    onChange={
                                                        cambiarCampo
                                                    }
                                                />

                                            </CobroCampo>

                                        )

                                        : null
                                }

                            </CobroCamposGrid>

                        </ModalSeccion>


                        {
                            errorFormulario
                                ? (

                                    <div
                                        style={{
                                            marginTop:
                                                '1rem',

                                            padding:
                                                '0.7rem',

                                            borderRadius:
                                                '8px',

                                            backgroundColor:
                                                '#FFF1F2',

                                            color:
                                                '#B45059',

                                            fontSize:
                                                '0.75rem'
                                        }}
                                    >
                                        {errorFormulario}
                                    </div>

                                )
                                : null
                        }


                        <ModalAcciones>

                            <BotonSecundario

                                type="button"

                                disabled={
                                    guardando
                                }

                                onClick={
                                    handleCerrar
                                }
                            >
                                Cancelar
                            </BotonSecundario>


                            <BotonPrincipal

                                type="submit"

                                disabled={
                                    guardando
                                }
                            >

                                {
                                    guardando
                                        ? 'Guardando...'
                                        : 'Guardar centro'
                                }

                            </BotonPrincipal>

                        </ModalAcciones>

                    </CobroFormulario>

                </ModalScrollContenido>

            </ModalEconomiaContenido>

        </Modal>

    );

};


export default CentroModal;